import type { StateCreator } from 'zustand';
import type {
  PreferencesState,
  StrategiesBannerSlice,
} from '../types/preferencesStoreTypes';

export const createBannerSlice: StateCreator<
  PreferencesState,
  [],
  [],
  StrategiesBannerSlice
> = (set) => ({
  isStrategiesBannerVisible: true,
  dismissStrategiesBanner: () => set({ isStrategiesBannerVisible: false }),
  resetStrategiesBanner: () => set({ isStrategiesBannerVisible: true }),
});
